import template from './employee_groups_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeeGroupsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeGroupsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeGroupsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeeGroupsHelp',
	dialog_class: EmployeeGroupsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_groups_help',
	provider: 'ps'
};
